// Helper function to ensure the filename has the correct extension for exports
export const getFinalFilename = (name: string, extension: string): string => {
  const trimmedName = name.trim();
  if (trimmedName.toLowerCase().endsWith(extension.toLowerCase())) {
    return trimmedName;
  } else {
    return `${trimmedName}${extension}`;
  }
};
